import { schemes, zSchema } from "@zeal/common";

const employeeAccrualBalanceSchema = zSchema.object({
  employeeID: schemes.mongoObjectId(),
  accrual_balance: zSchema.number(),
});

export const patchAccrualBalanceRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  policy_code: zSchema.string(),
  employees: zSchema.array(employeeAccrualBalanceSchema),
});

export type TPatchAccrualBalanceRequestSchema = zSchema.infer<
  typeof patchAccrualBalanceRequestSchema
>;

export const patchAccrualBalanceResponseSchema = zSchema.object({
  companyID: schemes.companyID(),
  policy_code: zSchema.string(),
  employees: zSchema.array(employeeAccrualBalanceSchema),
  invalidEmployeeIDs: zSchema.array(zSchema.string()).optional(),
});

export type TPatchAccrualBalanceResponseSchema = zSchema.infer<
  typeof patchAccrualBalanceResponseSchema
>;
